function isCushyBumTemplateCart() {
  return document.body && document.body.hasAttribute('data-cb-template-cart');
}

function getCushyTemplateCartDrawer() {
  return isCushyBumTemplateCart() ? document.querySelector('cart-drawer') : null;
}

document.addEventListener(
  'click',
  (event) => {
    if (!isCushyBumTemplateCart()) return;

    const cartLink = event.target && event.target.closest && event.target.closest('#cart-icon-bubble');
    const drawer = getCushyTemplateCartDrawer();
    if (!cartLink || !drawer) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    drawer.open(cartLink);
  },
  true
);

document.addEventListener(
  'keydown',
  (event) => {
    if (!isCushyBumTemplateCart() || String(event.code || '').toUpperCase() !== 'SPACE') return;

    const cartLink = event.target && event.target.closest && event.target.closest('#cart-icon-bubble');
    const drawer = getCushyTemplateCartDrawer();
    if (!cartLink || !drawer) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    drawer.open(cartLink);
  },
  true
);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      if (isCushyBumTemplateCart()) {
        event.stopImmediatePropagation();
      }
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (String(event.code || '').toUpperCase() === 'SPACE') {
        event.preventDefault();
        if (isCushyBumTemplateCart()) {
          event.stopImmediatePropagation();
        }
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const isEmpty = parsedState.item_count === 0;
    if (typeof parsedState.item_count === 'number') {
      this.classList.toggle('is-empty', isEmpty);
    } else if (parsedState.items && Array.isArray(parsedState.items)) {
      this.classList.toggle('is-empty', parsedState.items.length === 0);
    } else if (parsedState.sections && parsedState.sections['cart-drawer']) {
      this.classList.remove('is-empty');
    }
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (!parsedState.sections || !parsedState.sections[section.id]) return;

      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!sectionElement) return;

      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    if (!this.classList.contains('is-empty')) {
      this.querySelectorAll('.drawer__inner-empty').forEach((element) => element.remove());
    }
    this.querySelectorAll('.title-wrapper-with-link, .cart__warnings').forEach((element) => {
      if (element.closest('cart-drawer-items')) element.remove();
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  refreshFromCart(openDrawer = true) {
    fetch(`${window.location.pathname}?sections=${this.getSectionsToRender().map((section) => section.id).join(',')}`, {
      headers: {
        Accept: 'application/json'
      }
    })
      .then((response) => response.json())
      .then((sections) => {
        return fetch('/cart.js', {
          headers: {
            Accept: 'application/json'
          }
        })
          .then((response) => response.json())
          .then((cart) => {
            cart.sections = sections;
            return cart;
          });
      })
      .then((cart) => {
        this.renderContents(cart);
        if (!openDrawer) this.close();
      })
      .catch((error) => {
        console.error('Cart drawer refresh failed', error);
        if (openDrawer) this.open();
      });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);

    return parsed ? parsed.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

class CartDrawerItems extends CartItems {
  connectedCallback() {
    this.cartUpdateUnsubscriber = undefined;
  }

  disconnectedCallback() {
    this.cartUpdateUnsubscriber = undefined;
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}
